"use strict";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { addFavoriteToken, removeFavoriteToken } from "features/favorites/slice";
import { MobileEventName } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
import { useCurrencyInfo } from "features/tokens/useCurrencyInfo";
import { currencyIdToAddress, currencyIdToChain } from "utils/uniswapCurrencyId";
export function useToggleFavoriteCallback(id, isFavoriteToken) {
  const dispatch = useDispatch();
  const token = useCurrencyInfo(id);
  return useCallback(() => {
    if (isFavoriteToken) {
      dispatch(removeFavoriteToken({ currencyId: id.toLowerCase() }));
    } else {
      sendAnalyticsEvent(MobileEventName.FavoriteItem, {
        address: currencyIdToAddress(id.toLowerCase()),
        chain: currencyIdToChain(id),
        type: "token",
        name: token?.currency.name
      });
      dispatch(addFavoriteToken({ currencyId: id.toLowerCase() }));
    }
  }, [dispatch, id, isFavoriteToken, token]);
}
